import { makeAutoObservable } from 'mobx'

class UserStore {
  user = {}

  constructor(rootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  setUser(user) {
    this.user = user
  }
}

export default UserStore
